import { Box, Chip, Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface HomeWorkItemProps {
  href: string;
  title: string;
  status: string;
  active: boolean;
  muted?: boolean;
  metadata: string;
}

export const HomeWorkItem = ({
  href,
  title,
  status,
  active,
  muted = false,
  metadata,
}: HomeWorkItemProps) => {
  const classes = useStyles();
  return (
    <Box className={classes.item}>
      <Link
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
      >
        <Box className={classes.header}>
          <Typography className={classes.title}>{title}</Typography>
          <Chip
            size="small"
            label={status}
            className={`${
              active ? classes.active : muted ? classes.muted : ''
            }`}
          />
        </Box>
        <Typography className={classes.metadata}>{metadata}</Typography>
      </Link>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  item: {
    minWidth: 0,
    '& + &': { borderTop: `1px solid ${theme.palette.border}` },
  },
  link: {
    display: 'block',
    padding: theme.spacing(1.25, 2),
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: -2,
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: '0.88rem',
    fontWeight: 600,
    lineHeight: 1.35,
    textDecoration: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '&:hover': { color: theme.palette.linkHover, textDecoration: 'none' },
  },
  metadata: {
    color: theme.palette.text.secondary,
    fontSize: '0.76rem',
    lineHeight: 1.4,
    marginTop: theme.spacing(0.5),
  },
  active: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? 'rgba(136, 202, 71, 0.18)'
        : 'rgba(76, 175, 80, 0.12)',
    color: theme.palette.success.main,
  },
  muted: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? 'rgba(168, 168, 178, 0.18)'
        : 'rgba(105, 115, 134, 0.14)',
    color: theme.palette.text.secondary,
  },
}));
